import { useMemo, useRef } from "react";
import { PolicyManagementRecord } from "entities/UIModel/PolicyManagementRecord";

function useSelectedRecords(
  records: PolicyManagementRecord[],
  selectedIds: string[]
): PolicyManagementRecord[] {
  const cacheRef = useRef(new Map<string, PolicyManagementRecord>());

  return useMemo(() => {
    const cache = cacheRef.current;
    const selected = new Set(selectedIds);

    records.forEach((record) => {
      if (selected.has(record.uniqueIdentifier)) {
        cache.set(record.uniqueIdentifier, record);
      }
    });

    Array.from(cache.keys()).forEach((id) => {
      if (!selected.has(id)) cache.delete(id);
    });

    return selectedIds
      .map((id) => cache.get(id))
      .filter((record): record is PolicyManagementRecord => Boolean(record));
  }, [records, selectedIds]);
}

export default useSelectedRecords;
